import { Component, OnInit, Input, Output, EventEmitter, ViewChild, TemplateRef } from '@angular/core';
import { IPartialAddress, AddressService, IAddress } from '../../services/address.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { LoaderService } from '../../services/loader.service';
import { finalize } from 'rxjs/operators';
import { AlertService } from '../../services/alert.service';
import { IonSelect } from '@ionic/angular';
import { MatDialog } from '@angular/material/dialog';
import { IStore, StoreService } from 'src/app/store/services/store.service';
import { GoogleApiService } from '../../services/google-api.service';
import { IGeopoint } from 'src/app/store/pages/list-page/list-page.component';
import { GeolocationHelpers } from 'src/app/helpers/geolocataion-helpers';
import { ValidatorsService } from '../../services/validators.service';

@Component({
    selector: 'shared-address-form',
    templateUrl: './address-form.component.html',
    styleUrls: ['./address-form.component.scss'],
    standalone: false
})
export class AddressFormComponent implements OnInit {
  @ViewChild('addressConfirmationDialog') public addressConfirmationDialog: TemplateRef<any>;
  @ViewChild('streetSelect') streetSelect: IonSelect;
  @Input() partialAddresses: IPartialAddress[];
  @Input() storeId: string;
  @Output() onAddressValidate: EventEmitter<IAddress> = new EventEmitter<IAddress>();
  currentStreet: IPartialAddress;
  form: FormGroup;
  formErrors: Map<string, string> = new Map<string, string>();
  useCustomAddress: boolean = false;

  SanitizedaddressModel: IAddress;

  patternReference: any = {};

  get addressModel() : IAddress {
    return {
      province: this.form.get('province').value,
      city: this.form.get('city').value,
      postalCode: this.currentStreet.postalCode,
      street: this.form.get('street').value,
      streetDirection: this.form.get('streetDirection').value,
      streetDirectory: this.form.get('streetDirection').value,
      streetType: this.form.get('streetType').value,
      suiteNumber: this.form.get('suiteNumber').value,
      streetNumber: this.form.get('streetNumber').value
    };
  }

  get customAddressModel() : IAddress {
    let fullAddress = this.form.get('streetAddress').value;
    let streetNumber = fullAddress.substring(0, fullAddress.indexOf(' '));
    let street = fullAddress.substring(fullAddress.indexOf(' ') + 1);
    this.form.get('streetNumber').setValue(+streetNumber);

    return {
      province: this.partialAddresses[0].provinceCode,
      city: this.form.get('city').value,
      postalCode: this.partialAddresses[0].postalCode,
      street: street,
      streetDirection: '',
      streetDirectory: '',
      streetType: '',
      suiteNumber: '',
      streetNumber: this.form.get('streetNumber').value
    };
  }

  get customAddress(){
    return this.form.get('streetAddress').value;
  }

  constructor(
    private fb: FormBuilder, 
    private dialog: MatDialog,
    private googleApiService: GoogleApiService,
    private addressService: AddressService,
    private loaderService: LoaderService,
    private alertService: AlertService,
    private storeService: StoreService,
    public validators: ValidatorsService) { }

  formatStreet(partialAddress: IPartialAddress): string {
    let ret = `${partialAddress.streetName || ''} ${partialAddress.streetDirectionCode || ''} (${partialAddress.streetTypeCode || ''})`;
    return ret;
  }

  ngOnInit() {
    /*
    this.form = this.fb.group({
      'postalCode': [{value: '', disabled: true}, this.validators.formBuilderValidationInitializer(true, null)],
      'province': [{value: '', disabled: true}, this.validators.formBuilderValidationInitializer(true, null)],
      'city': [{value: '', disabled: true}, this.validators.formBuilderValidationInitializer(true, null)],
      'street': [{value: '', disabled: true}, this.validators.formBuilderValidationInitializer(true, null)],
      'streetType': [{value: '', disabled: true}, this.validators.formBuilderValidationInitializer(true, null)],
      'streetDirection': [{value: '', disabled: true}, this.validators.formBuilderValidationInitializer(false, null)],
      'streetNumber': ['', this.validators.formBuilderValidationInitializer(true, null)],
      'suiteNumber': ['', this.validators.formBuilderValidationInitializer(false, null)],
      'streetAddress': ['', this.validators.formBuilderValidationInitializer(false, null)],
    });
    */
    this.form = this.fb.group({
      postalCode: this.fb.control({ value: '', disabled: true }, {
        validators: this.validators.formBuilderValidationInitializer(true, null),
        updateOn: 'change'
      }),
      province: this.fb.control({ value: '', disabled: true }, {
        validators: this.validators.formBuilderValidationInitializer(true, null),
        updateOn: 'change'
      }),
      city: this.fb.control({ value: '', disabled: true }, {
        validators: this.validators.formBuilderValidationInitializer(true, null),
        updateOn: 'change'
      }),
      street: this.fb.control({ value: '', disabled: true }, {
        validators: this.validators.formBuilderValidationInitializer(true, null),
        updateOn: 'change'
      }),
      streetType: this.fb.control({ value: '', disabled: true }, {
        validators: this.validators.formBuilderValidationInitializer(true, null),
        updateOn: 'change'
      }),
      streetDirection: this.fb.control({ value: '', disabled: true }, {
        validators: this.validators.formBuilderValidationInitializer(false, null),
        updateOn: 'change'
      }),
      streetNumber: this.fb.control('', {
        validators: this.validators.formBuilderValidationInitializer(true, null),
        updateOn: 'change'
      }),
      suiteNumber: this.fb.control('', {
        validators: this.validators.formBuilderValidationInitializer(false, null),
        updateOn: 'change'
      }),
      streetAddress: this.fb.control('', {
        validators: this.validators.formBuilderValidationInitializer(false, null),
        updateOn: 'change'
      })
    });

    /*
    this.form["patternReference"] = {
      postalCode: null,
      province: null,
      city: null,
      street: null,
      streetType: null,
      streetDirection: null,
      streetNumber: null,
      suiteNumber: null,
      streetAddress: null
    };
    */
    this.patternReference = {
      postalCode: null,
      province: null,
      city: null,
      street: null,
      streetType: null,
      streetDirection: null,
      streetNumber: null,
      suiteNumber: null,
      streetAddress: null
    };

    //this.validators.trackInputChange(this.form);
    this.validators.trackInputChange(this.form, this.patternReference);
  }

  




  onStreetUpdated() {
    if(this.currentStreet){
      this.form.get('province').setValue(this.currentStreet.provinceCode);
      this.form.get('city').setValue(this.currentStreet.city);
      this.form.get('street').setValue(this.currentStreet.streetName);
      this.form.get('streetType').setValue(this.currentStreet.streetTypeCode);
      this.form.get('streetDirection').setValue(this.currentStreet.streetDirectionCode);
      this.form.get('streetAddress').setValue('');
      this.streetSelect.selectedText = this.formatStreet(this.streetSelect.value);
      this.useCustomAddress = false;
    } else {
      // all streets with same postal code should be in same city
      this.form.get('city').setValue(this.partialAddresses[0].city);
      this.streetSelect.selectedText = "Enter your street address";
      this.streetSelect.disabled = true;
      this.useCustomAddress = true;
    } 
  }

  onStreetClose(){
    if(this.useCustomAddress){
      this.streetSelect.disabled = true;
    }
  }

  openStreetSelect(){
    this.streetSelect.disabled = false;
    this.streetSelect.open();
  }

  toUpperCase(){
    let address = this.form.get('streetAddress').value;
    this.form.get('streetAddress').setValue(address.toString().toUpperCase());
  }

  confirmAddress(){
    this.onAddressValidate.emit(this.customAddressModel);
  }

  async submit() {

    if(!this.useCustomAddress){
      //sanitizing
      this.SanitizedaddressModel = this.validators.multiSanitizerInput(this.addressModel);

      const loader = await this.loaderService.create();
      //this.addressService.validate(this.addressModel)
      this.addressService.validate(this.SanitizedaddressModel)
      .pipe(finalize(async () => {
        await loader.dismiss();
      }))
      .subscribe((result) => {
        if (result === true){
          if(this.storeId == null){
            //this.onAddressValidate.emit(this.addressModel);
            this.onAddressValidate.emit(this.SanitizedaddressModel);
          } else {
            this.validateStoreRange();
          }
        }
        else
        this.alertService.showTranslate('Address.InvalidStreet');

        
      });
    } else {
      // will have to verify the sanitization here

      let fullAddress = this.form.get('streetAddress').value;
      let spaceIndex = fullAddress.indexOf(' ');
      let streetNumber = fullAddress.substring(0, spaceIndex);
      let street = fullAddress.substring(spaceIndex + 1); 
      if(spaceIndex < 0 || isNaN(streetNumber) || isNaN(parseFloat(streetNumber)) || street.length == 0){
        this.alertService.showTranslate('Address.InvalidCustomStreet');
      } else {
        this.dialog.open(this.addressConfirmationDialog, {width: "350px", maxWidth: "100%" });
      }
    } 
  }

  // check if address is in range of a specific store for delivery
  validateStoreRange() {
    this.googleApiService.getAddressGeometry(this.addressModel).subscribe((data) => {
      let geopoint: IGeopoint = {
        latitude: data.lat,
        longitude: data.lng
      };

      this.storeService.getStore(this.storeId).subscribe(store => {
        if (this.addressModel) {
          if (store.postalCodesDelivery && store.postalCodesDelivery.length > 0) {
            let found = store.postalCodesDelivery.indexOf(this.addressModel.postalCode) > -1;
            if (found) {
              this.onAddressValidate.emit(this.addressModel);
              return;
            }
          }
    
          if(store.deliveryZone && store.deliveryZone.deliveryZone != null && store.deliveryZone.deliveryZone.length > 0){
            //need to find a point for the current address to compare with the points
            let found = false;
            store.deliveryZone.deliveryZone.forEach(zone => {
              if(this.storeService.inside(geopoint, zone.points)){
                this.onAddressValidate.emit(this.addressModel);
                return;
              }
            });
          }
        }

        store._distance = GeolocationHelpers.distance(geopoint.latitude, geopoint.longitude, store.address.latitude, store.address.longitude);

        if (store._distance <= store.deliveryRadius ) {
          this.onAddressValidate.emit(this.addressModel);
          return;
        }
      
        this.alertService.showTranslate('Address.InvalidAddress');
      });
    })
  }
}
